import { Static, Type } from "@fastify/type-provider-typebox";
import { Address, UserRole } from "./auth";
import { SettingsResponse } from "./setting";

export enum AssistantStatus {
  PENDING = "PENDING",
  ACTIVE = "ACTIVE",
  REMOVED = "REMOVED"
};

export enum AssistantPermissions {
  SALES_PERMISSION            = 1 << 0,  // 0001
  INVENTORY_PERMISSION        = 1 << 1,  // 0010
  CREATE_SHIPMENTS_PERMISSION = 1 << 2,
  MANAGE_SHIPMENT_PERMISSION  = 1 << 3,
  READ_SHIPMENTS_PERMISSION   = 1 << 4,
  DASHBOARD_PERMISSION        = 1 << 5,
};

export const AssistantResponse = Type.Object({
  uuid: Type.String(),
  name: Type.String(),
  email: Type.String(),
  role: Type.Enum(UserRole),
  settings: Type.Optional(SettingsResponse),
  sellers: Type.Optional(Type.Array(Type.Object({
    uuid: Type.String(),
    email: Type.String(),
    name: Type.String(),
    role: Type.Enum(UserRole),
    permissions: Type.Integer(),
    status: Type.Enum(AssistantStatus)
  }))),

  assistants: Type.Optional(Type.Array(Type.Object({
    relationId: Type.Integer(),
    uuid: Type.String(),
    email: Type.String(),
    name: Type.String(),
    role: Type.Enum(UserRole),
    permissions: Type.Integer(),
    emailVerified: Type.Boolean(),
    status: Type.Enum(AssistantStatus)
  }))),
});

export const AssistantCreationBody = Type.Object({
  name: Type.String(),
  email: Type.String(),
  permissions: Type.Integer(),
  message: Type.Optional(Type.String()),
});
  
export const AssistantCreationResponse = Type.Object({
  uuid: Type.String(),
  email: Type.String(),
  role: Type.Enum(UserRole),
  sellerUUID: Type.String(),
  status: Type.Enum(AssistantStatus),
  permissions: Type.Integer(),
  settings: Type.Optional(SettingsResponse),
  relationId: Type.Integer(),
});
  
export type AssistantResponse = Static<typeof AssistantResponse>;
export type AssistantCreationBody = Static<typeof AssistantCreationBody>;  
export type AssistantCreationResponse = Static<typeof AssistantCreationResponse>;

export const VerifyAssistantBody = Type.Object({
  token: Type.String(),
});
export type VerifyAssistantBody = Static<typeof VerifyAssistantBody>;